import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { KidsPerformance } from './pages/KidsPerformance';
import { Learning } from './pages/Learning';
import { GrowthTracking } from './pages/GrowthTracking';
import { ToyDetail } from './pages/ToyDetail';
import { AIBot } from './pages/AIBot';
import { Notifications } from './pages/Notifications';
import { PhoneContainer } from './components/PhoneContainer';
export function AppRouter() {
  return <BrowserRouter data-id="element-48">
      <PhoneContainer data-id="element-49">
        <Routes data-id="element-50">
          <Route path="/" element={<App data-id="element-52" />} data-id="element-51" />
          <Route path="/kids-performance/:childId" element={<KidsPerformance data-id="element-54" />} data-id="element-53" />
          <Route path="/learning" element={<Learning data-id="element-56" />} data-id="element-55" />
          <Route path="/aibot" element={<AIBot data-id="element-58" />} data-id="element-57" />
          <Route path="/growth" element={<GrowthTracking data-id="element-60" />} data-id="element-59" />
          <Route path="/toy/:toyId" element={<ToyDetail data-id="element-62" />} data-id="element-61" />
          <Route path="/tasks" element={<Learning data-id="element-64" />} data-id="element-63" />
          <Route path="/notifications" element={<Notifications data-id="element-66" />} data-id="element-65" />
        </Routes>
      </PhoneContainer>
    </BrowserRouter>;
}